import { FC } from "react";
import InnerPage from "../../../../shared/components/InnerPage";
import { PATHS } from "../../../../paths";

const QualityManagementPage: FC = () => (
  <InnerPage
    eyebrow="Kurumsal"
    title="Kalite Yönetim Programı"
    crumbs={[{ label: "Hakkımızda", to: PATHS.about }, { label: "Kalite Yönetim Programı" }]}
    seoDescription="Securitas İtfaiye Hizmetleri A.Ş., sürekli öğrenme, iyileştirme ve risk yönetimi amaçlarıyla yasal zorunlulukları gözeterek etkin ve verimli itfaiye hizmetleri sunar."
    withSidebar
  >
    <div className="it-prose">
      <h2>Kalite Yönetim Programı</h2>
      <p>
        Securitas İtfaiye Hizmetleri A.Ş., sürekli öğrenme, iyileştirme, geliştirme
        ve risk yönetimi amaçları doğrultusunda, yasal zorunlulukları gözeterek,
        etkin ve verimli İtfaiye Hizmetleri sunar.
      </p>
      <p>
        Securitas Türkiye İş Yönetimi Politikası (POL-ÜB-100) kapsamında
        oluşturduğumuz esaslar doğrultusunda yaptığımız çalışmaları taahhüt ederiz.
      </p>
    </div>
  </InnerPage>
);

export default QualityManagementPage;
